import React from 'react';

const Label = ({ children }) => (
  <span className="label">{children}:&nbsp;</span>
);

export default Label;
